export default class Proveedor {
    constructor(proveedor) {
        if (proveedor) {
            this.id = proveedor.id || '';
            this.cliente_id = proveedor.cliente_id;
            this.rif = proveedor.rif || '';
            this.name =  proveedor.name || '';
            this.porcentaje_retencion =  proveedor.porcentaje_retencion || '';
            this.email = proveedor.email || '';
            this.phone = proveedor.phone || '';
            this.tipo_proveedor = proveedor.tipo_proveedor || 'PJD';
        }
    }

    get primaryText() { 
        return this.name; 
    }

    get secondaryText() { 
        return this.rif + ' | ' + this.percentage + '%';
    }

    set percentage(val) {
        this.porcentaje_retencion = val;
    }
    get percentage() { 
        return this.porcentaje_retencion;
    }

    /**
     * Handle when one of the form input changes it's value
     * 
     * @param {Event} Event (onChange)
     * @return {Proveedor}
     */
    handleInputChange(e) {
        let proveedor = this;
        switch(e.target.name) {
            case 'name':
                proveedor.name = e.target.value;
            break;

            case 'rif':
                proveedor.rif = e.target.value.toUpperCase();
                let char = proveedor.rif.charAt(0);

                if (char === 'V')
                    proveedor.tipo_proveedor = 'PND';
                if (char === 'J')
                    proveedor.tipo_proveedor = 'PJD';

            break;

            case 'email':
                proveedor.email = e.target.value;
            break;

            case 'phone':
                proveedor.phone = e.target.value;
            break;

            case 'tipo_proveedor':
                proveedor.tipo_proveedor = e.target.value;
                break;

            case 'percentage':
                proveedor.percentage = e.target.value;
            break;
        }

        return proveedor;
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/Models/Proveedor.js
 **/